module.exports = __webpack_public_path__ + "static/media/1001713DO.fa3a3a04.jpg";